const BLOCK_SELECTOR = 'p, li, ol, ul, h1, h2, h3, h4, h5, h6, blockquote';

// Lets each paragraph pick its own direction from its text. Bilingual (MENA)
// stories mix English and Arabic paragraphs inside a container that may be
// dir="rtl", so paragraphs without an explicit direction would otherwise
// inherit the wrong one. Inline `direction` styles still take precedence.
export function withAutoTextDirection(html: string): string {
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  doc.body.querySelectorAll(BLOCK_SELECTOR).forEach((element) => {
    if (!element.hasAttribute('dir')) {
      element.setAttribute('dir', 'auto');
    }
  });
  return doc.body.innerHTML;
}
